var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 218.51 173.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#a8e600"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.89 0H0v106.93a33.39 33.39 0 0 0 33.39 33.4h110.5a33.39 33.39 0 0 0 33.39-33.4V33.39A33.39 33.39 0 0 0 143.89 0zm-33.75 108.3H66.05v-7.59h44.09zm35.64-17.66H66.05v-7.58h79.73zm0-17.65H66.05V65.4h79.73zm39.34-39.6H185v76.69a37.4 37.4 0 0 1-37.4 37.4h-113a33.4 33.4 0 0 0 32.61 26.24h151.3V66.79a33.39 33.39 0 0 0-33.39-33.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.78 140.33V66.79a33.34 33.34 0 0 1 1-8 33.34 33.34 0 0 0-1 8v73.54h0zm2.93-87.21a32.85 32.85 0 0 1 2.77-5 32.85 32.85 0 0 0-2.77 5zM35 58l.67-2.16A12.56 12.56 0 0 0 35 58z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.17,33.39a33.39,33.39,0,0,0-33.39,33.4v73.54H143.89a33.39,33.39,0,0,0,33.39-33.4V33.39Zm43,74.91H66.05v-7.59h44.09Zm35.64-17.66H66.05V83.06h79.73Zm0-17.65H66.05V65.4h79.73Z",
    fill: "#3cbf00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat-icon.a804dca8cdef843f66d540039a4a527b.svg";
export { ForwardRef as ReactComponent };